async function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const initCardObserverAnimation = (elements: NodeListOf<Element>) => {
  const cardObserver = new IntersectionObserver((entries) => {
    entries.forEach(async(entry) => {
      if (entry.isIntersecting) {
        const cards = entry.target;        
        const classList = Array.from(cards.classList);

        if (!classList.includes('cover')) {
          cards.classList.add('cover');
          await sleep(200);
        }
      }
    })
  })

  elements.forEach((image) => {
    cardObserver.observe(image);
  })
}